export const formatInsight = {
	methods: {
		roundNumber (numberToRound: string|number, decimalPlaces: number): number {
			var parsedNumber = typeof numberToRound === "string" ? Number.parseFloat(numberToRound) : numberToRound

			// toFixed will enforce decimal places even for whole numbers - use % to check if it is a whole number
			var result = parsedNumber % 1 === 0 ? numberToRound : parsedNumber.toFixed(decimalPlaces)
			return typeof result === "string" ? Number.parseFloat(result) : result
		}
	}
}
